<template>
  <div class="page-bg">
    <!-- Header -->
    <Header
      :headerTitle="$t('m.orderList.title')"
      :hasBackBtn="true"
      :rightTitle="$t('m.orderList.rightTitle')"
      :onRightBtnClick="onRightBtnClick"
      :iconShow="true"
    ></Header>

    <div
      class="main-container" 
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="200"
    >
    <!-- section orderList -->
      <section style="margin-bottom:0px;" v-if="resultList!=''">
        <div class="headerInfo items" v-for="(item,index) in resultList" :key="index">
          <div class="radios" @click="orderByDetail(item.orderId,item.status,item.extraPayStatus)">
            <h6>
              {{$i18n.locale==='zh_CN' ? item.parkingName : item.parkingEnName}}
              <span v-if="item.extraPayStatus==2" style="color:#ff9933">{{$t('m.orderList.extraPayStatus')}}</span>
              <span v-if="item.status==1 && item.extraPayStatus!=2" style="color:#ff9933">{{$t('m.orderList.status1')}}</span>
              <span v-if="item.status==2 && item.extraPayStatus!=2" style="color:#009900">{{$t('m.orderList.status2')}}</span>
              <span v-if="item.status==3 && item.extraPayStatus!=2 && item.extraPayStatus!=3"  style="color:#019858">{{$t('m.orderList.status3')}}</span>
              <span v-if="item.status==3 && item.extraPayStatus==3"  style="color:#019858">{{$t('m.orderList.status3s')}}</span>
              <span v-if="item.status==4 && item.extraPayStatus!=2" style="color:#666">{{$t('m.orderList.status4')}}</span>
              <span v-if="item.status==5 && item.extraPayStatus!=2" style="color:#ff9933">{{$t('m.orderList.status5')}}</span>
              <span v-if="item.status==6 && item.extraPayStatus!=2" style="color:#008aac">{{$t('m.orderList.status6')}}</span>
              <span v-if="item.status==7 && item.extraPayStatus!=2" style="color:#c30808">{{$t('m.orderList.status7')}}</span>
			  <span v-if="item.status==8 && item.extraPayStatus!=2" style="color:#c30808">{{$t('m.orderList.status8')}}</span>
			  <span v-if="item.status==9 && item.extraPayStatus!=2" style="color:#c30808">{{$t('m.orderList.status9')}}</span>
            </h6>
            <p>
              {{$t('m.orderList.reservedInTime')}}：{{item.appointInTime}}
              <!-- <span
                style="color:#666;"
              >&nbsp;超时时间{{(item.timeoutTime/60).toFixed(2)}}小时 | {{item.timeoutAmount}}元</span>-->
            </p>
            <p>
               {{$t('m.orderList.reservedHour')}}：{{item.appointTime/60}}{{$t('m.orderList.hours')}}

              <span style="color:#666;" v-if="$t('m.orderList.reservedMone')=='CNY'">￥{{item.amount?item.amount:0}} for {{$t('m.orderList.reservedMoneyTitle')}}</span>
              <span style="color:#666;" v-else>&nbsp; {{$t('m.orderList.reservedMoneyTitle')}}{{item.amount?item.amount:0}}{{$t('m.orderList.reservedMone')}}</span>
            </p>
          </div>
          <!--去支付 button -->
          <div
            class="buttoms"
            style="border-top: 2px solid #efefef;"
            v-if="item.status==1 ||item.status==5"
          >
            <button
              class="btn success paymentOrder"
              style="margin-top:10px;"
              @click="orderByDetail(item.orderId,item.status)"
            >{{$t('m.orderList.pay')}}</button>
          </div>
        </div>
      </section>
      <div v-if="resultList==''">{{$t('m.orderList.nullDate')}}</div>
    </div>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
    <b-modal ref="limitOrderCount" id="limitOrderCount" centered hide-header ok-only :ok-title="$t('m.orderList.ok')">
      <h5>{{$t('m.orderList.uncompletedTips')}}</h5>
    </b-modal>
  </div>
</template>
<script>
import { orderList } from "../../api/order.js";

export default {
  name: "OrderList",
  data() {
    return {
      resultList: [], //数据
      page: 1,//当前页码
      pageSize: 10,//每页显示多少
      busy: false,//是否下拉
      total: 0,
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //发票
    onRightBtnClick: function() {
      this.$router.push("/invoicing");
    },
    //页面加载的数据
    loadOrderList: function() {
      let orderIds = this.$route.params.orderIds;
      let req = { page: this.page, pageSize: this.pageSize };
      if (orderIds != undefined && orderIds != null && orderIds != 0) {
        req.orderIds = orderIds;
      }
      orderList(req).then(
        response => {
          if (response.data.status == 200) {
            response.data.result.forEach(d => {
              if(!d.bmwOrder || d.bmwOrder == null ){
                this.resultList.push(d);
              }
            });

            this.total = response.data.total;
            this.busy = false;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    },
    //列表操作
    orderByDetail: function(orderId, status,extraPayStatus) {
      if(extraPayStatus==2){
           this.$router.push("/excessOrder/"+orderId);
            return;
      }else if(extraPayStatus==3 && status==3){
          this.$refs.limitOrderCount.show();
          return;
      }
      //未支付页面
      if (status == 1) {
        this.$router.push("/SubmitOrder/" + orderId);
      } else if (status == 5) {
        //超时支付页面
        this.$router.push("/overtimeOrder/" + orderId);
      } else if (status == 2) {
        //待进场页面
        var type=0;
        this.$router.push("/staySubmitOrder/" + orderId+"/"+type);
      } else if (status == 3) {
        //已进场页面
        this.$router.push("/Time/" + orderId);
      } else {
        //订单详情页面
        this.$router.push("/orderDetails/" + orderId);
      }
    },
    loadMore() {
      this.busy = true;
      let pages = Math.ceil(this.total / this.pageSize);
      if (this.page < pages) {
        this.page++;
        this.loadOrderList();
      } else {
        this.busy = false;
      }
    }
  },
  //加载事件
  created() {
    this.loadOrderList();
  }
};
</script>
<style>
section .radios {
  margin-bottom: 6px;
}
section .headerInfo {
  margin-top: 0px;
}
section .headerInfo .radios {
  text-align: left;
}
section .headerInfo .custom-control {
  width: 100%;
}
section .headerInfo label {
  width: 100%;
}
section .headerInfo .radios p span {
  display: inline-block;
  float: right;
  font-size: 13px;
  color: #f5c265;
}
section .headerInfo .radios h6{
  font-size: 14px;
  color: #424242;
}
section .headerInfo .radios h6 span {
  display: inline-block;
  float: right;
  font-size: 13px;
  color: #f5c265;
}
section .headerInfo .buttoms {
  text-align: right;
}
section .items {
  border-top: 0px solid #e9e9e9;
  padding: 10px;
  margin: 10px;
  background: white;
  box-shadow: 0 8px 12px 0 rgb(0,0,0,.1);
  border-radius: 5px;

}
section .items:first-child{
  border-top: 0;
}
section .headerInfo a {
  background-color: #0066B1;
  padding: 5px 25px;
  text-align: center;
  border: 0px;
}
section .headerInfo a:link {
  background-color: #0066B1;
}
section .headerInfo .radios p span b {
  border: #f5c265 solid 1px;
  border-radius: 2px;
  font-size: 11px;
}
section .headerInfo .radios p {
  font-size: 13px;
  color: #A1A1A1;
}
section .buttoms button {
  background-color: #0066B1;
  color: #fff;
  line-height: 20px;
  width: 28%;
}
 #limitOrderCount {
  width: 80%;
  margin: 0 auto;
 }
 #limitOrderCount .modal-body {
  padding-bottom: 0;
}
 #limitOrderCount .modal-body h5 {
  font-size: 1.02rem;
  margin: 10px 0;
}
 #limitOrderCount .modal-footer{
   padding: 10px;
 }
 #limitOrderCount .modal-footer .btn-primary {
  width: 60%;
  margin: 0 auto;
  line-height: 1.9rem;
  font-size: 1.05rem;
  letter-spacing: 2.2px;
  background-color: #0061B1;
  border: 0px;
}

</style>

